module.exports = __webpack_public_path__ + "static/media/backed_by_iag.cb6f60db.svg";